import {
  ElementType,
  ComponentPropsWithoutRef,
  CSSProperties,
  forwardRef,
} from 'react';
import classNames from 'classnames';
import { Colors } from '../../styles';
import styles from './Card.module.scss';

interface _CardProps<T extends ElementType> {
  padding?: string | number;
  backgroundColor?: Colors;
  className?: string;
  as?: T;
}

export type CardProps<T extends ElementType> = ComponentPropsWithoutRef<T> &
  _CardProps<T>;

function Card<T extends ElementType = 'div'>(
  { backgroundColor, className, padding, as, ...props }: CardProps<T>,
  ref: any,
) {
  const Component = as ?? 'div';
  return (
    <Component
      {...props}
      style={
        {
          '--card-p': typeof padding === 'number' ? `${padding}rem` : padding,
        } as CSSProperties
      }
      className={classNames(
        backgroundColor && styles[`card--bg-${backgroundColor}`],
        styles.card,
        className,
      )}
      ref={ref}
    />
  );
}

export default forwardRef(Card);
